module.exports = __webpack_public_path__ + "static/media/dev-header.b98a73a4.png";